export default __webpack_public_path__ + "static/certificado-9001_2024-0cbb8b3ef64c984418e69487d18eef94.pdf";